module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAWQAAAFkBqp2phgAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAADFSURBVDiNrdPrbQIxEATg7x5VgBTKQIiUAfRBJ1cHCUeKQCiFAFXwyI8zQjoWDhRGWsnyrMc7Xi/84BzEDoMUuzs5KzihcIsakxR1wBc4lchwDBIOibus2zgiywPiJZTYYxlU8YkK/S6BEYYBV2GD6SOB3NVnG/f2byrY4FdsYdIlkGn6Gd22wJfmD3xj3eILDMsnqry8Qy/g5m9pYxfGGiuRheoZgV46PAu4878t5JouRMNUuk5dVGmROCvxqG7x4fE413+LYTqMsBpw4gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/enterprise/Dashboard_16x16.png
// module id = GPV7
// module chunks = 0